module.exports = __webpack_public_path__ + "media/notification1.08f21256.mp3";